<template>
  <section class="z-1 position-relative">
    <div class="sticky-top bg-dark d-flex flex-column">
      <div class="row g-0">
		<div class="col-12">
			<div class="px-4 d-flex align-items-center justify-content-center justify-content-md-start">
            	<h1 class="display-1 fs-2 fw-bold p-3 bg-white rounded-2 text-dark ms-0 ms-md-5">Reviews</h1>
          	</div>
		</div>
        <div class="content col-5 d-flex flex-column justify-content-between z-1">
          <!-- <div class="px-4 d-flex align-items-center">
            <h1 class="display-1 fs-2 fw-bold p-3 bg-white rounded-2 text-dark ms-5">Reviews</h1>
          </div> -->
        </div>
      </div>
      <div class="row g-0 px-0 pb-2 bg- flex-fill">
		<div class="grad d-flex py-3 overflow-scroll">
			<ReviewCard revieweeName="Tamlin" quote="Rezaar is an extraordinary full-stack developer whose technical prowess is matched only by his unwavering dedication to excellence. His ability to seamlessly navigate complex ..." image="https://i.ibb.co/gtr9dP0/tamlin.jpg" :stars="stars(4)" linkedin="https://www.linkedin.com/in/tamlin-leigh-geyer-8a6169225/"/>
			<ReviewCard revieweeName="Ntokozo" quote="Rezaar is an intelligent individual, always willing to help where he can. He is passionate about his work and executes his creativity with excellence." image="https://i.ibb.co/g7LN46D/image.png" :stars="stars(5)" linkedin="https://www.linkedin.com/in/ntokozo-sithebe/"/>
			<ReviewCard revieweeName="Razien" quote="Rezaar is extremely focused. When he sinks hes teeth into something he does not let go. Hes everyone's go to guy and he's always willing to help. He showcases diligence ..." image="https://i.ibb.co/5TQBp3R/DSC-0302.jpg" :stars="stars(5)" linkedin="https://www.linkedin.com/in/razien-mackenzie/"/>
		</div>
	  </div>
    </div>
  </section>
</template>
<style scoped>
.grad {
    box-shadow: inset 0 0 20px 10px rgba(0,0,0,0.3);
}
</style>
<script>
import ReviewCard from '@/components/ReviewCard.vue';

export default {
	name: "ReviewsView",
	components: {
		ReviewCard
	},
	methods: {
		stars(number){
			if( number > 5 ){
				number = 5
			} else if (number < 1) {
				number = 0
			}
			return new Array(number); 
		}
	}
}
</script>
